import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { getNavigationSidebarProjectSettingsResource } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { legacyProjectSettingsScreensRoute } from '@jira/router-routes__legacy-project-settings-screens-routes/src/legacyProjectSettingsScreensRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyProjectSettingsScreensRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(legacyProjectSettingsScreensRoute, () => ({
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			getConsolidationStateResource(),
		],

		entryPoint: () => pageEntryPoint,
	}));
